import { getUserAgnosticGlobalFeatureGatesFromMemory } from '@src/modules/global-state/user-agnostic-feature-gates.browser'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

const DESIGN_SYSTEM_GATE_NAME = 'ssr-use-design-system-components'
const DESIGN_SYSTEM_QUERY_PARAM_KEY = 'is_ds'

export const DOCUMENT_HTML_DATA_STYLES_ATTR = 'data-styles'
export const DOCUMENT_HTML_DATA_STYLES_VALUE = 'panda'

export function shouldUseDesignSystem(): boolean {
  if (isBrowser()) {
    return document.documentElement.getAttribute(DOCUMENT_HTML_DATA_STYLES_ATTR) === DOCUMENT_HTML_DATA_STYLES_VALUE
  }

  const featureGates = getUserAgnosticGlobalFeatureGatesFromMemory()
  return Boolean(featureGates[DESIGN_SYSTEM_GATE_NAME])
}

export function isDesignSystemEnabledFromNextData(nextData: {
  props?: { pageProps?: { userAgnosticGlobalFeatureGates?: Record<string, boolean | undefined> } }
  query?: Record<string, string | string[] | undefined>
}): boolean {
  if (nextData.props?.pageProps?.userAgnosticGlobalFeatureGates?.[DESIGN_SYSTEM_GATE_NAME]) {
    return true
  }

  const queryValue = nextData.query?.[DESIGN_SYSTEM_QUERY_PARAM_KEY]
  return (Array.isArray(queryValue) ? queryValue[0] : queryValue) === 'true'
}
